import axios from "axios";

const API = axios.create({
  // baseURL: "http://localhost:5015",
  baseURL: "https://api-auraskinpremium.bin-mohammad-tech.com",
  withCredentials: true, // ✅ send cookies automatically
});

if (typeof window !== "undefined") {
  console.info("[Auraskin] API client base URL:", API.defaults.baseURL);
}


// Attach accessToken
API.interceptors.request.use((config) => {
  const token = localStorage.getItem("accessToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 with refresh
API.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        // ✅ just call refresh, cookie sent automatically
        const res = await API.post(
          "/api/auth/refresh",
          {},
          { withCredentials: true }
        );

        const newAccessToken = res.data.accessToken;
        localStorage.setItem("accessToken", newAccessToken);

        originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
        return API(originalRequest);
      } catch (err) {
        localStorage.removeItem("accessToken");

        setTimeout(() => {
          window.location.href = "/login";
        }, 1000);
        // window.location.href = "/login";
        // console.log('renavigate');
      }
    }
    return Promise.reject(error);
  }
);

export default API;
